module.exports = __webpack_public_path__ + "9302f49db0771985a0802985ce219ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-rabbit-good-work.png
// module id = 2046
// module chunks = 4